export default "__VITE_ASSET__HpXNH$FY__"